var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_631_2060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7686 1.539H13.8673V0.78125C13.8673 0.349731 13.5176 0 13.0861 0H6.94C6.50848 0 6.15875 0.349731 6.15875 0.78125V1.539H4.25781C3.18085 1.539 2.30469 2.41516 2.30469 3.49213V18.0469C2.30469 19.1238 3.18085 20 4.25781 20H15.7686C16.8456 20 17.7217 19.1238 17.7217 18.0469V3.49213C17.7217 2.41516 16.8454 1.539 15.7686 1.539ZM12.3048 1.5625V3.07816H7.7211C7.7211 2.5589 7.7211 2.12997 7.7211 1.5625H12.3048ZM16.1592 18.0469C16.1592 18.2623 15.9839 18.4375 15.7686 18.4375H4.25781C4.04236 18.4375 3.86719 18.2623 3.86719 18.0469V3.49213C3.86719 3.27682 4.04236 3.1015 4.25781 3.1015H6.1586V3.85941C6.1586 4.29092 6.50848 4.64066 6.93985 4.64066H13.0861C13.5175 4.64066 13.8673 4.29092 13.8673 3.85941V3.1015H15.7686C15.9839 3.1015 16.1592 3.27682 16.1592 3.49213V18.0469ZM13.6383 9.12186C13.9435 9.42703 13.9435 9.92172 13.6383 10.2267L9.53278 14.3323C9.22775 14.6375 8.73306 14.6375 8.42789 14.3323L6.38763 12.292C6.08261 11.987 6.08261 11.4923 6.38763 11.1871C6.69281 10.8821 7.18735 10.8821 7.49252 11.1871L8.98041 12.675L12.5334 9.12201C12.8386 8.81683 13.3331 8.81683 13.6383 9.12186Z",
    fill: "#6B6E7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_631_2060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/Clipboard.2a13ec95e4a9652ebe5c9c8adfb54d7d.svg";
export { ForwardRef as ReactComponent };